import { useState } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/da0nvqe859p3u981e4tg";

const footerLinks = [
  { href: "#library", label: "画风库" },
  { href: "#style-guide", label: "画风推荐" },
  { href: "#popular", label: "热门精选" },
  { href: "#wiki", label: "画风百科" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于漫屿" },
];

const styleTags = ["水彩晕染", "水墨国风", "清新淡彩", "厚涂光影", "复古手绘", "赛璐璐上色", "铅笔线稿", "电影感分镜"];

export default function Footer() {
  const [status, setStatus] = useState<{ type: "idle" | "success" | "error"; msg: string }>({ type: "idle", msg: "" });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const hp = String(fd.get("website_alt") || "").trim();
    if (hp) {
      setStatus({ type: "success", msg: "感谢订阅！每周会为你推送精选画风作品。" });
      form.reset();
      return;
    }
    fd.delete("website_alt");
    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = {};
      }
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus({ type: "success", msg: "感谢订阅！每周会为你推送精选画风作品。" });
        form.reset();
      } else {
        const errMsg =
          parsed?.meta?.message || parsed?.meta?.detail || "订阅失败，请稍后再试。";
        setStatus({ type: "error", msg: String(errMsg) });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，请稍后再试。" });
    }
  };

  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-brush-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-900">漫屿</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              按画风筛选与推荐 BL 漫画的精选站，收录作画精美细腻的作品，助你快速找到心仪画风。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-900">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="whitespace-nowrap text-sm text-foreground-700 transition hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold text-foreground-900">热门画风</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {styleTags.slice(0, 6).map((t) => (
                <li key={t}>
                  <a href="#library" className="whitespace-nowrap text-sm text-foreground-700 transition hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-900">订阅画风资讯</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              留下邮箱，每周为你推荐新收录的精美画风作品。
            </p>
            <form
              id="newsletter-form"
              data-readdy-form="newsletter"
              onSubmit={handleSubmit}
              className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-contact"
              />
              <input
                type="email"
                name="email"
                required
                placeholder="你的邮箱地址"
                className="h-11 w-full rounded-full border border-background-300 bg-background-50 px-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
              />
              <button
                type="submit"
                className="h-11 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                订阅
              </button>
            </form>
            {status.type === "success" && (
              <p className="mt-3 text-sm text-primary-700">{status.msg}</p>
            )}
            {status.type === "error" && (
              <p className="mt-3 text-sm text-red-600">{status.msg}</p>
            )}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 漫屿 · BL漫画画风筛选与推荐</p>
          <p className="text-xs text-foreground-600">作画之美，值得被认真欣赏</p>
        </div>
      </div>
    </footer>
  );
}